import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectStageTicket = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti,
    notClose
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const [arrOpt, setArrOpt] = useState([
        {
            value: 'Abierto',
            label: 'Abierto'
        },
        {
            value: 'Fecha Asignada',
            label: 'Fecha Asignada'
        },
        {
            value: 'Fecha Pendiente de Asignar',
            label: 'Fecha Pendiente de Asignar'
        },
        {
            value: 'En Espera',
            label: 'En Espera'
        },
        {
            value: 'En Curso',
            label: 'En Curso'
        },
        {
            value: 'Cliente no contesta',
            label: 'Cliente no contesta'
        },
        {
            value: 'Reprogramar',
            label: 'Reprogramar'
        },
        {
            value: 'En Gestion Cobranza',
            label: 'En Gestion Cobranza'
        },
        {
            value: 'En Espera de DA',
            label: 'En Espera de DA'
        },
        {
            value: 'Cerrado',
            label: 'Cerrado'
        }
    ]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(notClose){
            setArrOpt([
                {
                    value: 'Abierto',
                    label: 'Abierto'
                },
                {
                    value: 'Fecha Asignada',
                    label: 'Fecha Asignada'
                },
                {
                    value: 'Fecha Pendiente de Asignar',
                    label: 'Fecha Pendiente de Asignar'
                },
                {
                    value: 'En Espera',
                    label: 'En Espera'
                },
                {
                    value: 'En Curso',
                    label: 'En Curso'
                },
                {
                    value: 'Cliente no contesta',
                    label: 'Cliente no contesta'
                },
                {
                    value: 'Reprogramar',
                    label: 'Reprogramar'
                },
                {
                    value: 'En Gestion Cobranza',
                    label: 'En Gestion Cobranza'
                },
                {
                    value: 'En Espera de DA',
                    label: 'En Espera de DA'
                },
            ])
        }
    }, [notClose])
    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(arrOpt.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = arrOpt.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value,arrOpt]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={arrOpt}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectStageTicket.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectStageTicket;